import { Link, NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

function Layout({ children }) {
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState(i18n.resolvedLanguage || i18n.language || 'en');

  useEffect(() => {
    const handler = (l) => setLang(l);
    i18n.on('languageChanged', handler);
    return () => i18n.off('languageChanged', handler);
  }, [i18n]);

  return (
    <div className={`min-h-screen bg-white text-slate-900 dark:bg-background dark:text-foreground transition-colors duration-300`}>
      <header className={`sticky top-0 z-50 backdrop-blur bg-white/70 dark:bg-background/70 border-b border-slate-200 dark:border-white/5`}>
        <div className="mx-auto max-w-6xl px-4 py-3 flex items-center justify-between">
          <Link to="/" className="font-semibold tracking-tight text-lg">
            AR<span className="text-accent">.</span>
          </Link>
          <nav className="hidden md:flex gap-6 text-sm">
            {[
              { to: '/', label: t('nav.home') },
              { to: '/about', label: 'About' },
              { to: '/projects', label: t('nav.projects') },
              { to: '/experience', label: t('nav.experience') },
              { to: '/blog', label: t('nav.blog') },
              { to: '/contact', label: t('nav.contact') },
            ].map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `hover:text-accent transition-colors ${isActive ? 'text-accent' : ''}`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-2">
            <select
              aria-label="Language"
              value={lang}
              onChange={(e) => i18n.changeLanguage(e.target.value)}
              className="h-9 rounded-lg bg-white/5 border border-white/10 px-2 text-sm"
            >
              <option value="en">EN</option>
              <option value="hi">HI</option>
            </select>
          </div>

        </div>
      </header>
      <main className="mx-auto max-w-6xl px-4 py-10">{children}</main>
      <footer className="border-t border-white/5 py-8 text-center text-xs text-foreground/70">
        © {new Date().getFullYear()} Ak. All rights reserved.
      </footer>
    </div>
  );
}

export default Layout;




